/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const countries_codes = [
  {
    label: "United States (+1)",
    value: "1",
    id: "US",
  },
  {
    label: "United Kingdom (+44)",
    value: "44",
    id: "GB",
  },
  {
    label: "France (+33)",
    value: "33",
    id: "FR",
  },

  {
    label: "Turkey (+90)",
    value: "90",
    id: "TR",
  },
  {
    label: "Qatar (+974)",
    value: "974",
    id: "QA",
  },
  {
    label: "Afghanistan (+93)",
    value: "93",
    id: "AF",
  },
  {
    label: "Aland Islands (+358)",
    value: "358",
    id: "AX",
  },
  {
    label: "Albania (+355)",
    value: "355",
    id: "AL",
  },
  {
    label: "Algeria (+213)",
    value: "213",
    id: "DZ",
  },
  {
    label: "AmericanSamoa (+1684)",
    value: "1684",
    id: "AS",
  },
  {
    label: "Andorra (+376)",
    value: "376",
    id: "AD",
  },
  {
    label: "Angola (+244)",
    value: "244",
    id: "AO",
  },
  {
    label: "Anguilla (+1264)",
    value: "1264",
    id: "AI",
  },
  {
    label: "Antarctica (+672)",
    value: "672",
    id: "AQ",
  },
  {
    label: "Antigua and Barbuda (+1268)",
    value: "1268",
    id: "AG",
  },
  {
    label: "Argentina (+54)",
    value: "54",
    id: "AR",
  },
  {
    label: "Armenia (+374)",
    value: "374",
    id: "AM",
  },
  {
    label: "Aruba (+297)",
    value: "297",
    id: "AW",
  },
  {
    label: "Australia (+61)",
    value: "61",
    id: "AU",
  },
  {
    label: "Austria (+43)",
    value: "43",
    id: "AT",
  },
  {
    label: "Azerbaijan (+994)",
    value: "994",
    id: "AZ",
  },
  {
    label: "Bahamas (+1242)",
    value: "1242",
    id: "BS",
  },
  {
    label: "Bahrain (+973)",
    value: "973",
    id: "BH",
  },
  {
    label: "Bangladesh (+880)",
    value: "880",
    id: "BD",
  },
  {
    label: "Barbados (+1246)",
    value: "1246",
    id: "BB",
  },
  {
    label: "Belarus (+375)",
    value: "375",
    id: "BY",
  },
  {
    label: "Belgium (+32)",
    value: "32",
    id: "BE",
  },
  {
    label: "Belize (+501)",
    value: "501",
    id: "BZ",
  },
  {
    label: "Benin (+229)",
    value: "229",
    id: "BJ",
  },
  {
    label: "Bermuda (+1441)",
    value: "1441",
    id: "BM",
  },
  {
    label: "Bhutan (+975)",
    value: "975",
    id: "BT",
  },
  {
    label: "Bolivia, Plurinational State of (+591)",
    value: "591",
    id: "BO",
  },
  {
    label: "Bosnia and Herzegovina (+387)",
    value: "387",
    id: "BA",
  },
  {
    label: "Botswana (+267)",
    value: "267",
    id: "BW",
  },
  {
    label: "Brazil (+55)",
    value: "55",
    id: "BR",
  },
  {
    label: "British Indian Ocean Territory (+246)",
    value: "246",
    id: "IO",
  },
  {
    label: "Brunei Darussalam (+673)",
    value: "673",
    id: "BN",
  },
  {
    label: "Bulgaria (+359)",
    value: "359",
    id: "BG",
  },
  {
    label: "Burkina Faso (+226)",
    value: "226",
    id: "BF",
  },
  {
    label: "Burundi (+257)",
    value: "257",
    id: "BI",
  },
  {
    label: "Cambodia (+855)",
    value: "855",
    id: "KH",
  },
  {
    label: "Cameroon (+237)",
    value: "237",
    id: "CM",
  },
  {
    label: "Canada (+1)",
    value: "1",
    id: "CA",
  },
  {
    label: "Cape Verde (+238)",
    value: "238",
    id: "CV",
  },
  {
    label: "Cayman Islands (+345)",
    value: "345",
    id: "KY",
  },
  {
    label: "Central African Republic (+236)",
    value: "236",
    id: "CF",
  },
  {
    label: "Chad (+235)",
    value: "235",
    id: "TD",
  },
  {
    label: "Chile (+56)",
    value: "56",
    id: "CL",
  },
  {
    label: "China (+86)",
    value: "86",
    id: "CN",
  },
  {
    label: "Christmas Island (+61)",
    value: "61",
    id: "CX",
  },
  {
    label: "Cocos (Keeling) Islands (+61)",
    value: "61",
    id: "CC",
  },
  {
    label: "Colombia (+57)",
    value: "57",
    id: "CO",
  },
  {
    label: "Comoros (+269)",
    value: "269",
    id: "KM",
  },
  {
    label: "Congo (+242)",
    value: "242",
    id: "CG",
  },
  {
    label: "Congo, The Democratic Republic of the Congo (+243)",
    value: "243",
    id: "CD",
  },
  {
    label: "Cook Islands (+682)",
    value: "682",
    id: "CK",
  },
  {
    label: "Costa Rica (+506)",
    value: "506",
    id: "CR",
  },
  {
    label: "Cote d'Ivoire (+225)",
    value: "225",
    id: "CI",
  },
  {
    label: "Croatia (+385)",
    value: "385",
    id: "HR",
  },
  {
    label: "Cuba (+53)",
    value: "53",
    id: "CU",
  },
  {
    label: "Cyprus (+357)",
    value: "357",
    id: "CY",
  },
  {
    label: "Czech Republic (+420)",
    value: "420",
    id: "CZ",
  },
  {
    label: "Denmark (+45)",
    value: "45",
    id: "DK",
  },
  {
    label: "Djibouti (+253)",
    value: "253",
    id: "DJ",
  },
  {
    label: "Dominica (+1767)",
    value: "1767",
    id: "DM",
  },
  {
    label: "Dominican Republic (+1849)",
    value: "1849",
    id: "DO",
  },
  {
    label: "Ecuador (+593)",
    value: "593",
    id: "EC",
  },
  {
    label: "Egypt (+20)",
    value: "20",
    id: "EG",
  },
  {
    label: "El Salvador (+503)",
    value: "503",
    id: "SV",
  },
  {
    label: "Equatorial Guinea (+240)",
    value: "240",
    id: "GQ",
  },
  {
    label: "Eritrea (+291)",
    value: "291",
    id: "ER",
  },
  {
    label: "Estonia (+372)",
    value: "372",
    id: "EE",
  },
  {
    label: "Ethiopia (+251)",
    value: "251",
    id: "ET",
  },
  {
    label: "Falkland Islands (Malvinas) (+500)",
    value: "500",
    id: "FK",
  },
  {
    label: "Faroe Islands (+298)",
    value: "298",
    id: "FO",
  },
  {
    label: "Fiji (+679)",
    value: "679",
    id: "FJ",
  },
  {
    label: "Finland (+358)",
    value: "358",
    id: "FI",
  },

  {
    label: "French Guiana (+594)",
    value: "594",
    id: "GF",
  },
  {
    label: "French Polynesia (+689)",
    value: "689",
    id: "PF",
  },
  {
    label: "Gabon (+241)",
    value: "241",
    id: "GA",
  },
  {
    label: "Gambia (+220)",
    value: "220",
    id: "GM",
  },
  {
    label: "Georgia (+995)",
    value: "995",
    id: "GE",
  },
  {
    label: "Germany (+49)",
    value: "49",
    id: "DE",
  },
  {
    label: "Ghana (+233)",
    value: "233",
    id: "GH",
  },
  {
    label: "Gibraltar (+350)",
    value: "350",
    id: "GI",
  },
  {
    label: "Greece (+30)",
    value: "30",
    id: "GR",
  },
  {
    label: "Greenland (+299)",
    value: "299",
    id: "GL",
  },
  {
    label: "Grenada (+1473)",
    value: "1473",
    id: "GD",
  },
  {
    label: "Guadeloupe (+590)",
    value: "590",
    id: "GP",
  },
  {
    label: "Guam (+1671)",
    value: "1671",
    id: "GU",
  },
  {
    label: "Guatemala (+502)",
    value: "502",
    id: "GT",
  },
  {
    label: "Guernsey (+44)",
    value: "44",
    id: "GG",
  },
  {
    label: "Guinea (+224)",
    value: "224",
    id: "GN",
  },
  {
    label: "Guinea-Bissau (+245)",
    value: "245",
    id: "GW",
  },
  {
    label: "Guyana (+595)",
    value: "595",
    id: "GY",
  },
  {
    label: "Haiti (+509)",
    value: "509",
    id: "HT",
  },
  {
    label: "Holy See (Vatican City State) (+379)",
    value: "379",
    id: "VA",
  },
  {
    label: "Honduras (+504)",
    value: "504",
    id: "HN",
  },
  {
    label: "Hong Kong (+852)",
    value: "852",
    id: "HK",
  },
  {
    label: "Hungary (+36)",
    value: "36",
    id: "HU",
  },
  {
    label: "Iceland (+354)",
    value: "354",
    id: "IS",
  },
  {
    label: "India (+91)",
    value: "91",
    id: "IN",
  },
  {
    label: "Indonesia (+62)",
    value: "62",
    id: "ID",
  },
  {
    label: "Iran, Islamic Republic of Persian Gulf (+98)",
    value: "98",
    id: "IR",
  },
  {
    label: "Iraq (+964)",
    value: "964",
    id: "IQ",
  },
  {
    label: "Ireland (+353)",
    value: "353",
    id: "IE",
  },
  {
    label: "Isle of Man (+44)",
    value: "44",
    id: "IM",
  },
  {
    label: "Israel (+972)",
    value: "972",
    id: "IL",
  },
  {
    label: "Italy (+39)",
    value: "39",
    id: "IT",
  },
  {
    label: "Jamaica (+1876)",
    value: "1876",
    id: "JM",
  },
  {
    label: "Japan (+81)",
    value: "81",
    id: "JP",
  },
  {
    label: "Jersey (+44)",
    value: "44",
    id: "JE",
  },
  {
    label: "Jordan (+962)",
    value: "962",
    id: "JO",
  },
  {
    label: "Kazakhstan (+77)",
    value: "77",
    id: "KZ",
  },
  {
    label: "Kenya (+254)",
    value: "254",
    id: "KE",
  },
  {
    label: "Kiribati (+686)",
    value: "686",
    id: "KI",
  },
  {
    label: "Korea, Democratic People's Republic of Korea (+850)",
    value: "850",
    id: "KP",
  },
  {
    label: "Korea, Republic of South Korea (+82)",
    value: "82",
    id: "KR",
  },
  {
    label: "Kuwait (+965)",
    value: "965",
    id: "KW",
  },
  {
    label: "Kyrgyzstan (+996)",
    value: "996",
    id: "KG",
  },
  {
    label: "Laos (+856)",
    value: "856",
    id: "LA",
  },
  {
    label: "Latvia (+371)",
    value: "371",
    id: "LV",
  },
  {
    label: "Lebanon (+961)",
    value: "961",
    id: "LB",
  },
  {
    label: "Lesotho (+266)",
    value: "266",
    id: "LS",
  },
  {
    label: "Liberia (+231)",
    value: "231",
    id: "LR",
  },
  {
    label: "Libyan Arab Jamahiriya (+218)",
    value: "218",
    id: "LY",
  },
  {
    label: "Liechtenstein (+423)",
    value: "423",
    id: "LI",
  },
  {
    label: "Lithuania (+370)",
    value: "370",
    id: "LT",
  },
  {
    label: "Luxembourg (+352)",
    value: "352",
    id: "LU",
  },
  {
    label: "Macao (+853)",
    value: "853",
    id: "MO",
  },
  {
    label: "Macedonia (+389)",
    value: "389",
    id: "MK",
  },
  {
    label: "Madagascar (+261)",
    value: "261",
    id: "MG",
  },
  {
    label: "Malawi (+265)",
    value: "265",
    id: "MW",
  },
  {
    label: "Malaysia (+60)",
    value: "60",
    id: "MY",
  },
  {
    label: "Maldives (+960)",
    value: "960",
    id: "MV",
  },
  {
    label: "Mali (+223)",
    value: "223",
    id: "ML",
  },
  {
    label: "Malta (+356)",
    value: "356",
    id: "MT",
  },
  {
    label: "Marshall Islands (+692)",
    value: "692",
    id: "MH",
  },
  {
    label: "Martinique (+596)",
    value: "596",
    id: "MQ",
  },
  {
    label: "Mauritania (+222)",
    value: "222",
    id: "MR",
  },
  {
    label: "Mauritius (+230)",
    value: "230",
    id: "MU",
  },
  {
    label: "Mayotte (+262)",
    value: "262",
    id: "YT",
  },
  {
    label: "Mexico (+52)",
    value: "52",
    id: "MX",
  },
  {
    label: "Micronesia, Federated States of Micronesia (+691)",
    value: "691",
    id: "FM",
  },
  {
    label: "Moldova (+373)",
    value: "373",
    id: "MD",
  },
  {
    label: "Monaco (+377)",
    value: "377",
    id: "MC",
  },
  {
    label: "Mongolia (+976)",
    value: "976",
    id: "MN",
  },
  {
    label: "Montenegro (+382)",
    value: "382",
    id: "ME",
  },
  {
    label: "Montserrat (+1664)",
    value: "1664",
    id: "MS",
  },
  {
    label: "Morocco (+212)",
    value: "212",
    id: "MA",
  },
  {
    label: "Mozambique (+258)",
    value: "258",
    id: "MZ",
  },
  {
    label: "Myanmar (+95)",
    value: "95",
    id: "MM",
  },
  {
    label: "Namibia (+264)",
    value: "264",
    id: "NA",
  },
  {
    label: "Nauru (+674)",
    value: "674",
    id: "NR",
  },
  {
    label: "Nepal (+977)",
    value: "977",
    id: "NP",
  },
  {
    label: "Netherlands (+31)",
    value: "31",
    id: "NL",
  },
  {
    label: "Netherlands Antilles (+599)",
    value: "599",
    id: "AN",
  },
  {
    label: "New Caledonia (+687)",
    value: "687",
    id: "NC",
  },
  {
    label: "New Zealand (+64)",
    value: "64",
    id: "NZ",
  },
  {
    label: "Nicaragua (+505)",
    value: "505",
    id: "NI",
  },
  {
    label: "Niger (+227)",
    value: "227",
    id: "NE",
  },
  {
    label: "Nigeria (+234)",
    value: "234",
    id: "NG",
  },
  {
    label: "Niue (+683)",
    value: "683",
    id: "NU",
  },
  {
    label: "Norfolk Island (+672)",
    value: "672",
    id: "NF",
  },
  {
    label: "Northern Mariana Islands (+1670)",
    value: "1670",
    id: "MP",
  },
  {
    label: "Norway (+47)",
    value: "47",
    id: "NO",
  },
  {
    label: "Oman (+968)",
    value: "968",
    id: "OM",
  },
  {
    label: "Pakistan (+92)",
    value: "92",
    id: "PK",
  },
  {
    label: "Palau (+680)",
    value: "680",
    id: "PW",
  },
  {
    label: "Palestinian Territory, Occupied (+970)",
    value: "970",
    id: "PS",
  },
  {
    label: "Panama (+507)",
    value: "507",
    id: "PA",
  },
  {
    label: "Papua New Guinea (+675)",
    value: "675",
    id: "PG",
  },
  {
    label: "Paraguay (+595)",
    value: "595",
    id: "PY",
  },
  {
    label: "Peru (+51)",
    value: "51",
    id: "PE",
  },
  {
    label: "Philippines (+63)",
    value: "63",
    id: "PH",
  },
  {
    label: "Pitcairn (+872)",
    value: "872",
    id: "PN",
  },
  {
    label: "Poland (+48)",
    value: "48",
    id: "PL",
  },
  {
    label: "Portugal (+351)",
    value: "351",
    id: "PT",
  },
  {
    label: "Puerto Rico (+1939)",
    value: "1939",
    id: "PR",
  },
  {
    label: "Romania (+40)",
    value: "40",
    id: "RO",
  },
  {
    label: "Russia (+7)",
    value: "7",
    id: "RU",
  },
  {
    label: "Rwanda (+250)",
    value: "250",
    id: "RW",
  },
  {
    label: "Reunion (+262)",
    value: "262",
    id: "RE",
  },
  {
    label: "Saint Barthelemy (+590)",
    value: "590",
    id: "BL",
  },
  {
    label: "Saint Helena, Ascension and Tristan Da Cunha (+290)",
    value: "290",
    id: "SH",
  },
  {
    label: "Saint Kitts and Nevis (+1869)",
    value: "1869",
    id: "KN",
  },
  {
    label: "Saint Lucia (+1758)",
    value: "1758",
    id: "LC",
  },
  {
    label: "Saint Martin (+590)",
    value: "590",
    id: "MF",
  },
  {
    label: "Saint Pierre and Miquelon (+508)",
    value: "508",
    id: "PM",
  },
  {
    label: "Saint Vincent and the Grenadines (+1784)",
    value: "1784",
    id: "VC",
  },
  {
    label: "Samoa (+685)",
    value: "685",
    id: "WS",
  },
  {
    label: "San Marino (+378)",
    value: "378",
    id: "SM",
  },
  {
    label: "Sao Tome and Principe (+239)",
    value: "239",
    id: "ST",
  },
  {
    label: "Saudi Arabia (+966)",
    value: "966",
    id: "SA",
  },
  {
    label: "Senegal (+221)",
    value: "221",
    id: "SN",
  },
  {
    label: "Serbia (+381)",
    value: "381",
    id: "RS",
  },
  {
    label: "Seychelles (+248)",
    value: "248",
    id: "SC",
  },
  {
    label: "Sierra Leone (+232)",
    value: "232",
    id: "SL",
  },
  {
    label: "Singapore (+65)",
    value: "65",
    id: "SG",
  },
  {
    label: "Slovakia (+421)",
    value: "421",
    id: "SK",
  },
  {
    label: "Slovenia (+386)",
    value: "386",
    id: "SI",
  },
  {
    label: "Solomon Islands (+677)",
    value: "677",
    id: "SB",
  },
  {
    label: "Somalia (+252)",
    value: "252",
    id: "SO",
  },
  {
    label: "South Africa (+27)",
    value: "27",
    id: "ZA",
  },
  {
    label: "South Sudan (+211)",
    value: "211",
    id: "SS",
  },
  {
    label: "South Georgia and the South Sandwich Islands (+500)",
    value: "500",
    id: "GS",
  },
  {
    label: "Spain (+34)",
    value: "34",
    id: "ES",
  },
  {
    label: "Sri Lanka (+94)",
    value: "94",
    id: "LK",
  },
  {
    label: "Sudan (+249)",
    value: "249",
    id: "SD",
  },
  {
    label: "Surilabel (+597)",
    value: "597",
    id: "SR",
  },
  {
    label: "Svalbard and Jan Mayen (+47)",
    value: "47",
    id: "SJ",
  },
  {
    label: "Swaziland (+268)",
    value: "268",
    id: "SZ",
  },
  {
    label: "Sweden (+46)",
    value: "46",
    id: "SE",
  },
  {
    label: "Switzerland (+41)",
    value: "41",
    id: "CH",
  },
  {
    label: "Syrian Arab Republic (+963)",
    value: "963",
    id: "SY",
  },
  {
    label: "Taiwan (+886)",
    value: "886",
    id: "TW",
  },
  {
    label: "Tajikistan (+992)",
    value: "992",
    id: "TJ",
  },
  {
    label: "Tanzania, United Republic of Tanzania (+255)",
    value: "255",
    id: "TZ",
  },
  {
    label: "Thailand (+66)",
    value: "66",
    id: "TH",
  },
  {
    label: "Timor-Leste (+670)",
    value: "670",
    id: "TL",
  },
  {
    label: "Togo (+228)",
    value: "228",
    id: "TG",
  },
  {
    label: "Tokelau (+690)",
    value: "690",
    id: "TK",
  },
  {
    label: "Tonga (+676)",
    value: "676",
    id: "TO",
  },
  {
    label: "Trinidad and Tobago (+1868)",
    value: "1868",
    id: "TT",
  },
  {
    label: "Tunisia (+216)",
    value: "216",
    id: "TN",
  },
  {
    label: "Turkmenistan (+993)",
    value: "993",
    id: "TM",
  },
  {
    label: "Turks and Caicos Islands (+1649)",
    value: "1649",
    id: "TC",
  },
  {
    label: "Tuvalu (+688)",
    value: "688",
    id: "TV",
  },
  {
    label: "Uganda (+256)",
    value: "256",
    id: "UG",
  },
  {
    label: "Ukraine (+380)",
    value: "380",
    id: "UA",
  },
  {
    label: "United Arab Emirates (+971)",
    value: "971",
    id: "AE",
  },

  {
    label: "Uruguay (+598)",
    value: "598",
    id: "UY",
  },
  {
    label: "Uzbekistan (+998)",
    value: "998",
    id: "UZ",
  },
  {
    label: "Vanuatu (+678)",
    value: "678",
    id: "VU",
  },
  {
    label: "Venezuela, Bolivarian Republic of Venezuela (+58)",
    value: "58",
    id: "VE",
  },
  {
    label: "Vietnam (+84)",
    value: "84",
    id: "VN",
  },
  {
    label: "Virgin Islands, British (+1284)",
    value: "1284",
    id: "VG",
  },
  {
    label: "Virgin Islands, U.S. (+1340)",
    value: "1340",
    id: "VI",
  },
  {
    label: "Wallis and Futuna (+681)",
    value: "681",
    id: "WF",
  },
  {
    label: "Yemen (+967)",
    value: "967",
    id: "YE",
  },
  {
    label: "Zambia (+260)",
    value: "260",
    id: "ZM",
  },
  {
    label: "Zimbabwe (+263)",
    value: "263",
    id: "ZW",
  },
];

export default countries_codes;
